export default "__VITE_ASSET__UBr2fXAG__"